import React, { useContext } from 'react'
import { Text } from 'react-native'
import { useTranslation } from 'react-i18next'
import { AuthContext } from '../../context/Auth/AuthContext'
import { AlertMessage } from '../AlertMessage'
import { styles } from '../AlertMessage/styles'
import { useContextApp } from '../../hooks/useContextApp'

interface Props {
  handleLogoutAlert: () => void
}
export const LogoutModal = ({ handleLogoutAlert }: Props) => {
  const {
    handleLogOut,
    freshWaterContext,
    controlServicesContext,
    seaWaterContext,
    necropsyContext,
    fuelContext,
  } = useContextApp()
  const { t } = useTranslation()

  return (
    <AlertMessage
      title={t('Cerrar sesión').toString()}
      action={() => {
        freshWaterContext.handleResetData()
        controlServicesContext.handleResetData()
        seaWaterContext.handleResetData()
        necropsyContext.handleResetData()
        fuelContext.handleResetData()
        handleLogOut()
      }}
      cancelButton
      actionCancelButton={() => handleLogoutAlert()}
    >
      <Text style={styles.textBody}>{t('¿Seguro que quieres cerrar sesión?')}</Text>
    </AlertMessage>
  )
}
